<div (clickOutside)="clickOutside()" class="language-dropdown">
  <div class="input-title">{{ title() }}</div>
  @if (selectedFranchise) {
    <div
      (click)="toggleDropdown()"
      [class.is-open]="isDropdownOpen"
      class="dropdown-input"
    >
      <app-franchise-icon [franchiseRoute]="selectedFranchise.route"></app-franchise-icon>
      <span>{{ value | translate }}</span>
      <i class="icon icon-CaretDown"></i>
    </div>
  }

  @if (isDropdownOpen && franchises()?.length) {
    <div class="dropdown-body">
      @for (item of franchises(); track item; ) {
        @for (frItem of item.localizations; track frItem; ) {
          <div class="item" (click)="selectFr(item, frItem)">
            <app-franchise-icon [franchiseRoute]="frItem.route"></app-franchise-icon>
            {{ getFrTitle(item, frItem) | translate }}
          </div>
        }
      }
    </div>
  }
</div>
